export default __webpack_public_path__ + "static/media/Vedant Dashmukhe.692ba2e1.jpeg";